import React from 'react'
import { motion, AnimateSharedLayout } from "framer-motion";

import styled from 'styled-components'

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${props => props.styles.width};
    background-color: ${props => props.styles.backgroundColor};
    border-radius: 5px;
    margin: ${props => props.styles.margin};
    font-size: ${props => props.styles.fontSize};
    font-weight: ${props => props.styles.fontWeight};
    /* padding: 0.3rem; */

`

const Tab = styled.div`
    color: ${props => props.selected  && props.type !== 'underline' ? 'white' : 'var(--text-color)'};
    display: block;
    position: relative;
    cursor: pointer;
    text-align: center;
    padding: ${props => props.styles.padding};
    background-color: transparent;
    flex-grow: 1;
    flex-basis: 0;
    border-left: ${props => !props.first & !props.type === 'plain' && '2px solid var(--secondary-color)'};
    width: ${props => props.styles.width};
    border-bottom: ${props => props.type !== 'plain' ? '0px solid transparent'
                            : (props.type === 'plain' & props.selected) ? '2px solid var(--focus-color)' 
                            : '2px solid transparent'};
    background-color: ${props => props.styles.backgroundColor};
    border-radius: ${props => props.styles.borderRadius};
    :hover {
        filter: ${props => props.type !== 'underline' && props.styles.backgroundColor && 'brightness(var(--brightness))'};
        color: ${props => !props.selected && props.styles.hoverTextColor};
    }
`

const Filler = styled.div`
    background-color: var(--focus-color);
    /* border-bottom: 2px solid var(--focus-color); */
    border-radius: 5px;
    height: 100%;
    width: 100%;
    opacity: 1;
`

const Underline = styled.div`
    border-bottom: 2px solid var(--focus-color);
    height: 100%;
    width: 100%;
    opacity: 1;
`

const Title = styled.div`
    font-size: 0.8rem;
    position: relative;
`

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

const Icon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0.5rem;
    color: ${props => props.selected ? 'white' : 'var(--text-color)'};
    z-index: ${props => props.selected && 1300};
`

const defaultStyle = {
    tab: {
        width: null,
        // backgroundColor: 'var(--primary-color)',
        backgroundColor: null,
        padding: '0.25rem',
        borderRadius: '5px',
        margin: '0 0 0.5rem 0',
        fontSize: '1rem',
        fontWeight: 'bold'
    },
    main: {
        width: 'min-content',
        backgroundColor: 'var(--primary-color)'
    }
}

const Tabs = (props) => {
    const {
        selected,
        options,
        icons,
        onSelect,
        type,
        styles
    } = props;
    let tabStyle = styles ? Object.assign({}, defaultStyle['tab'], styles['tab']) : defaultStyle['tab']
    let containerStyle = styles ? Object.assign({}, defaultStyle['main'], styles['main']) : defaultStyle['main']

    let blocks = []
    for (const [index, [key, value]] of Object.entries(Object.entries(options))) {
        blocks.push(
            <Tab key={key} styles={tabStyle} type={type}
                onClick={() => onSelect(key)} 
                selected={key === selected} 
                first={parseInt(index)=== 0}>
                {type === 'plain' ? null 
                : selected === key ? 
                <motion.div layoutId="outline" style={{width: '100%', height: '100%', position: 'absolute', top: 0, left: 0}}
                    initial={false}
                    animate={{ backgroundColor: 'transparent'}}
                    transition={{duration: 0.3}}>
                    {type === 'underline' ? <Underline/> : <Filler/>}
                </motion.div>
                : null}
                {icons ? 
                <Wrapper>
                    <Icon selected={key === selected}>{icons[key]}</Icon>
                    <Title>{value}</Title>
                </Wrapper>
                : <Title>{value}</Title>}
            </Tab>
        )
    }
    return (
        <Container styles={containerStyle}>
            <AnimateSharedLayout>
                {blocks}
            </AnimateSharedLayout>
        </Container>
    )
}

export default Tabs;
